// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag-suggestion_tag__3j8CJ","dark":"tag-suggestion_dark__3c1qy"};